module.exports = __webpack_public_path__ + "static/media/otherdoc.2db504c6.png";